import styled from 'styled-components';

export const StyledContent = styled.div`
  position: relative;
  .add-worker-dialog-container {
    margin-bottom: 1.8rem;
  }
`;
